<pbc-filter-preset
  [filter]="berichte.preset$ | async"
  [filters]="berichte.presets$ | async"
  [name]="berichte.search$ | async"
  (select)="berichte.setFilter($event)"
  (save)="berichte.writeFilter($event)"
  (delete)="berichte.deleteFilter($event)"
></pbc-filter-preset>
